import { useTranslation } from 'react-i18next';
import { Preloader } from '@/components/Preloader';
import { useGetInvestmentStreakStatus } from '@/query/queries/streak/useGetInvestmentStreakStatus';
import { StreakStatus } from './components/StreakStatus';
import { MilestoneProgress } from './components/MilestoneProgress';
import { MilestoneRewards } from './components/MilestoneRewards';
import { LeaderBoards } from './components/LeaderBoards';
import { StreakLossMessage } from './components/StreakLossMessage';
import { StreakStatusModal } from './modals/StreakStatusModal';
import { StreaksFaq } from './components/Faq';
import s from './index.module.scss';

const InvestmentStreakPage = () => {
  const { data: status, isLoading } = useGetInvestmentStreakStatus();
  const { t } = useTranslation('streak');
  return (
    <div className="container-inner">
      <div className={s.wrapper}>
        <div className={s.header}>
          <h1 className="f-hero-h2">{t('streak_page.investment_streak')}</h1>
          <p className="f-paragraph-regular" style={{ maxWidth: '720px' }}>
            {t('streak_page.participation_description')}
          </p>
        </div>
        {isLoading ? (
          <Preloader className={s.preloader} />
        ) : status ? (
          <>
            <StreakLossMessage status={status} />
            <StreakStatus status={status} />
            <MilestoneProgress status={status} />
            <MilestoneRewards status={status} />
            <LeaderBoards status={status} />
            <StreaksFaq />
          </>
        ) : null}
        <StreakStatusModal data={status} />
      </div>
    </div>
  );
};

export default InvestmentStreakPage;
